/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  CustomerUserService,
  type Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto,
} from '@wealthlane/api-services/wealthlane-customer-service';
import { resolveTenantScope } from '../../constants/tenantScope';
import { refreshSystemUsersTable } from '@/apps/customer/domains/system-users/refreshSystemUsersTable';

const usePostSystemUsers = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void,
  id?: string
): UseMutationResult<
  Wealthlane_CustomerService_Dtos_CustomerUser_CustomerUserDto | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      if (id != null && id !== '') {
        return await handleRequest(
          CustomerUserService.putApiCustomerApiAppCustomerUserCustomerUser({
            ...payload,
            id,
            scope: resolveTenantScope(payload.scope),
          })
        );
      } else {
        return await handleRequest(
          CustomerUserService.postApiCustomerApiAppCustomerUserCustomerUser({
            ...payload,
            scope: resolveTenantScope(payload.scope),
          })
        );
      }
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          closeModal();
          toast.success(
            <ToastComponent
              label='Success'
              message={`User ${id != null && id !== '' ? 'edited' : 'added'}`}
            />
          );
          refreshSystemUsersTable();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSystemUsers;
